import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import "./InboxPage.scss";

const FaqItem = ({ faq, onToggle }) => {
  const [t] = useTranslation();

  return (
    <div className="faq">
      <div className="faq-wrapper">
        <div className="question-wrapper" onClick={() => onToggle(faq)}>
          <span className="question">{t(faq.question)}</span>
          <span className="icon">{faq.opened ? "remove" : "add"}</span>
        </div>
        {faq.opened && <p className="answer trans-fromTop">{faq.answer}</p>}
      </div>
    </div>
  );
};

export function InboxPage() {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const [faqs, setFaqs] = useState([
    {
      question: "What is Iddink's main educational focus?",
      answer:
        "What is Iddink's main educational focus?What is Iddink's main educational focus?What is Iddink's main educational focus?",
      opened: false,
    },
    {
      question: "What is Iddink's main educational focus?",
      answer:
        "What is Iddink's main educational focus?What is Iddink's main educational focus?What is Iddink's main educational focus?",
      opened: false,
    },
    {
      question: "What is Iddink's main educational focus?",
      answer:
        "What is Iddink's main educational focus?What is Iddink's main educational focus?What is Iddink's main educational focus?",
      opened: false,
    },
    {
      question: "What is Iddink's main educational focus?",
      answer:
        "What is Iddink's main educational focus?What is Iddink's main educational focus?What is Iddink's main educational focus?",
      opened: false,
    },
    {
      question: "What is Iddink's main educational focus?",
      answer:
        "What is Iddink's main educational focus?What is Iddink's main educational focus?What is Iddink's main educational focus?",
      opened: false,
    },
    {
      question: "What is Iddink's main educational focus?",
      answer:
        "What is Iddink's main educational focus?What is Iddink's main educational focus?What is Iddink's main educational focus?",
      opened: false,
    },
    {
      question: "What is Iddink's main educational focus?",
      answer:
        "What is Iddink's main educational focus?What is Iddink's main educational focus?What is Iddink's main educational focus?",
      opened: false,
    },
    {
      question: "What is Iddink's main educational focus?",
      answer:
        "What is Iddink's main educational focus?What is Iddink's main educational focus?What is Iddink's main educational focus?",
      opened: false,
    },
    {
      question: "What is Iddink's main educational focus?",
      answer:
        "What is Iddink's main educational focus?What is Iddink's main educational focus?What is Iddink's main educational focus?",
      opened: false,
    },
    {
      question: "What is Iddink's main educational focus?",
      answer:
        "What is Iddink's main educational focus?What is Iddink's main educational focus?What is Iddink's main educational focus?",
      opened: false,
    },
  ]);

  useEffect(() => {
    const openWindow = window.open("https://www.iddink.nl/kennisbank-view/#/category/inleveren", "_blank");
    if (openWindow) {
      openWindow.focus();
      navigate(-1)
    }
  }, []);

  const toggleFaq = (clickedFaq) => {
    const updatedFaqs = faqs.map((faq) => {
      if (faq === clickedFaq) {
        return { ...faq, opened: !faq.opened };
      } else {
        return { ...faq };
      }
    });
    setFaqs(updatedFaqs);
  };

  return (
    <div className="inboxPage">
      {/* <div className="content trans-fromTop">
        <div className="header">
          <span className="description">{t("Help")}</span>
          <span className="title">{t("FaqsTitle")}</span>
        </div>
        <div className="faq-grid">
          {faqs.map((faq, index) => (
            <FaqItem key={index} faq={faq} onToggle={toggleFaq} />
          ))}
        </div>
        <div className="footer">
          <span className="description">{t("MoreQuestions")}</span>
          <Button className="button" onClick={() => {}}>
            {t("ContactUs")}
          </Button>
        </div>
      </div> */}
    </div>
  );
}
